import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';

const defaultItemActiveColorVars = {
  '--tabs-item-color': m('--action-text-default-color'),
  '--tabs-item-hover-color': m('--action-text-hover-color'),
  '--tabs-item-active-color': m('--action-text-active-color'),
  '--tabs-indicator-hover-color': m('--action-indicator-hover-color'),
  '--tabs-indicator-active-color': m('--action-indicator-active-color'),
};

export const lightTabVars: MotifComponentProps<MotifComponent.TABS> = {
  '--tabs-underline-color': m('--neutral-v250'),
  ...defaultItemActiveColorVars,
};

export const darkTabVars: MotifComponentProps<MotifComponent.TABS> = {
  '--tabs-underline-color': m('--action-indicator-hover-color'),
  ...defaultItemActiveColorVars,
};
